import React, {Component, Fragment} from "react";
import {Card} from "reactstrap";
import "flag-icon-css/css/flag-icon.css";
import {withRouter} from "react-router-dom";

class BeneficiaryExistingCard extends Component {

    constructor(props) {
        super(props);

        this.transact = this.props.transactAllowed !== undefined ? this.props.transactAllowed : false
    }

    render() {
        return <Fragment>
            {this.renderBeneficiaryCards(this.props.beneficiary)}
        </Fragment>
    }

    renderBeneficiaryCards(beneficiary) {
        return <Fragment>
            <Card
                style={{border: "none", cursor: "pointer"}}
            >
                <div className={"beneficiary_existing_card_header_div"}>
                    {this.renderHeader(beneficiary)}
                </div>
            </Card>
            <hr/>
        </Fragment>
    }

    renderHeader(beneficiary) {
        return <Fragment>
            <div style={{display: "flex", width: "100%"}}>
                <div>
                    <div style={{fontWeight: "bold"}}>
                        {beneficiary.beneficiaryName}
                    </div>
                    <span>{this.props.beneficiary.payoutPartnerName}</span>
                </div>
            </div>
        </Fragment>
    }
}

export default withRouter(BeneficiaryExistingCard);